import $ from 'jquery';
import Mustache from 'mustache';

const DEFAULT_ANIMATE_PARAMS = {
  outCss: {
    opacity: 0,
  },
  inCss: {
    opacity: 1,
  },
  fade: 750,
  hold: 1500,
  keep: true,
}

const PageType = Object.freeze({
  PDP: {
    name: 'PDP',
    getContainer: (code) => $('.sp-wrapper'),
    animateParams: {
      keep: false
    },
  },
  PLP: {
    name: 'PLP',
    getContainer: (code) => $(`#${code} .sp-wrapper`),
  },
  CART: {
    name: 'CART',
    getContainer: (code) => $(`tr[data-code='${code}'] .sp-wrapper`),
  },
});

function render(pageType, codes) {
  const urlParams = new URLSearchParams(window.location.search);
  const forceParam = window.rcProps.socialProof.forceParam;

  $.ajax({
    url: `${window.rcProps.socialProof.href}?${forceParam}=${urlParams.get(forceParam) || ''}`,
    method: 'POST',
    data: JSON.stringify({
      type: pageType.name,
      codes: Array.isArray(codes) ? codes : [codes],
    }),
    dataType: 'json',
    contentType: 'application/json'
  }).done((result) => {
    const animateParams = $.extend(DEFAULT_ANIMATE_PARAMS, pageType.animateParams);

    result.forEach((socialProof) => {
      if (socialProof.productCode) {
        let promise = Promise.resolve();

        for (let i = 0; i < socialProof.messages.length; i++) {
          const message = socialProof.messages[i];

          const $container = pageType.getContainer(socialProof.productCode).first();
          if ($container.length) {
            promise = promise.then(function() {
              return new Promise(function(resolve) {
                const $message = $(message.message).css(animateParams.outCss);
                $container.append($message.animate(animateParams.inCss, animateParams.fade,
                  function() {
                    if (!animateParams.keep) {
                      setTimeout(function() {
                        $message.css(animateParams.outCss);
                        setTimeout(function() {
                          $container.empty();
                          resolve();
                        }, animateParams.fade);
                      }, animateParams.hold);
                    }
                  }));
              });
            });
          }
        }
      }
    });
  }).fail((error) => {
    console.error(error);
  })
}

export const renderPdpSocialProof = (codes) => render(PageType.PDP, codes);
export const renderPlpSocialProof = (codes) => render(PageType.PLP, codes);
export const renderCartSocialProof = (codes) => render(PageType.CART, codes);



// WEBPACK FOOTER //
// ./src/scripts/modules/social-proof.js